import React, { Component, Fragment } from 'react';
import { Link, Navigate } from 'react-router-dom';
import axios from 'axios';
import AccountHeader from './AccountHeader';
import HomeAffiliatePill from './HomeAffiliatePill';
import PublicEvents from './PublicEvents';
import '../static/css/Home.css';
import eventCardImage from '../static/images/images/event-card-image.png';
import pausedMelodySleeping from '../static/images/images/paused-account-melody-sleeping.gif';
import AppStoreButtons from './AppStoreButtons';
import { trackScreen, SCREEN } from '../analytics';


class Home extends Component {
    constructor() {
        super();
        const userJson = localStorage.getItem('user');
        const eventJson = localStorage.getItem('upcoming_event');
        this.state = {
            status: 'verifying',
            user: userJson ? JSON.parse(userJson) : null,
            upcomingEvent: eventJson ? JSON.parse(eventJson) : null,
            birth_month: 'Select Birth Month',
            birth_day: 'Select Birth Day', 
            birth_year: 'Select Birth Year',
            birthdate_error: '',
            isSubmittingBirthdate: false,
        };
        this.onChangeBirthMonth = this.onChangeBirthMonth.bind(this);
        this.onChangeBirthDay = this.onChangeBirthDay.bind(this);
        this.onChangeBirthYear = this.onChangeBirthYear.bind(this);
        this.onSubmitBirthdate = this.onSubmitBirthdate.bind(this);
    }

    componentDidMount() {
        // screen_view, deduped module-scope in analytics.js — do NOT add a local guard.
        // No-ops entirely when signed out.
        trackScreen(SCREEN.HOME);

        const token = localStorage.getItem('token');
        if (!token) {
            this.setState({ status: 'unauthorized' });
            return;
        }
        axios.post(
            process.env.REACT_APP_SERVER_API + '/auth/web-session',
            {},
            { headers: { Authorization: 'Bearer ' + token } }
        ).then((response) => {
            const { user, upcoming_event } = response.data.data;
            localStorage.setItem('user', JSON.stringify(user));
            localStorage.setItem('upcoming_event', JSON.stringify(upcoming_event));
            this.setState({
                status: 'authorized',
                user: user,
                upcomingEvent: upcoming_event,
            });
        }).catch(() => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('upcoming_event');
            this.setState({ status: 'unauthorized' });
        });
    }

    formatBirthdate(birthdateStr) {
        if (!birthdateStr) return '';
        const dateOnly = String(birthdateStr).split('T')[0];
        const [year, month, day] = dateOnly.split('-').map(Number);
        if (!year || !month || !day) return '';
        const d = new Date(year, month - 1, day);
        return d.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        });
    }

    // ── Birthdate prompt helpers (mirror SignUpInfo / CommunitySignUp pattern) ──

    months = [
        { label: 'Jan', value: '01' }, { label: 'Feb', value: '02' },
        { label: 'Mar', value: '03' }, { label: 'Apr', value: '04' },
        { label: 'May', value: '05' }, { label: 'Jun', value: '06' },
        { label: 'Jul', value: '07' }, { label: 'Aug', value: '08' },
        { label: 'Sep', value: '09' }, { label: 'Oct', value: '10' },
        { label: 'Nov', value: '11' }, { label: 'Dec', value: '12' },
    ];

    daysInMonth = (year, monthValue) => {
        const y = parseInt(year, 10);
        const m = parseInt(monthValue, 10);
        if (!y || !m) return 31;
        return new Date(y, m, 0).getDate();
    };

    pad2 = (n) => String(n).padStart(2, '0');

    buildBirthdateString = (year, monthValue, day) => {
        if (!year || !monthValue || !day) return "";
        return `${String(year)}-${String(monthValue)}-${this.pad2(day)}`;
    };

    is18OrOlder = (yyyy, mm, dd) => {
        const year = parseInt(yyyy, 10);
        const month = parseInt(mm, 10);
        const day = parseInt(dd, 10);
        if (!year || !month || !day) return false;
        const birth = new Date(year, month - 1, day);
        if (birth.getFullYear() !== year || birth.getMonth() !== (month - 1) || birth.getDate() !== day) {
            return false;
        }
        const now = new Date();
        const cutoff = new Date(now.getFullYear() - 18, now.getMonth(), now.getDate());
        return birth <= cutoff;
    };

    onChangeBirthMonth(event) {
        const monthValue = event.target.value;
        this.setState((prev) => {
            const maxDay = prev.birth_year !== 'Select Birth Year' && monthValue !== 'Select Birth Month'
                ? this.daysInMonth(prev.birth_year, monthValue) : 31;
            const currentDayInt = parseInt(prev.birth_day, 10);
            const shouldResetDay = prev.birth_day !== 'Select Birth Day' && (!currentDayInt || currentDayInt > maxDay);
            const nextDay = shouldResetDay ? 'Select Birth Day' : prev.birth_day;
            return { birth_month: monthValue, birth_day: nextDay, birthdate_error: '' };
        });
    }

    onChangeBirthDay(event) {
        this.setState({ birth_day: event.target.value, birthdate_error: '' });
    }

    onChangeBirthYear(event) {
        const yearValue = event.target.value;
        this.setState((prev) => {
            const maxDay = yearValue !== 'Select Birth Year' && prev.birth_month !== 'Select Birth Month'
                ? this.daysInMonth(yearValue, prev.birth_month) : 31;
            const currentDayInt = parseInt(prev.birth_day, 10);
            const shouldResetDay = prev.birth_day !== 'Select Birth Day' && (!currentDayInt || currentDayInt > maxDay);
            const nextDay = shouldResetDay ? 'Select Birth Day' : prev.birth_day;
            return { birth_year: yearValue, birth_day: nextDay, birthdate_error: '' };
        });
    }

    birth_month_options() {
        return this.months.map(m => (
            <option value={m.value} key={m.value}>{m.label}</option>
        ));
    }

    birth_year_options() {
        const nowYear = new Date().getFullYear();
        const maxYear = nowYear - 18;
        const start = nowYear - 100;
        const years = [];
        for (let y = maxYear; y >= start; y--) years.push(y);
        return years.map(y => (
            <option value={String(y)} key={String(y)}>{String(y)}</option>
        ));
    }

    birth_day_options() {
        const { birth_year, birth_month } = this.state;
        let max = 31;
        if (birth_year !== 'Select Birth Year' && birth_month !== 'Select Birth Month') {
            max = this.daysInMonth(birth_year, birth_month);
        }
        const days = [];
        for (let d = 1; d <= max; d++) days.push(d);
        return days.map(d => (
            <option value={String(d)} key={String(d)}>{String(d)}</option>
        ));
    }

    async onSubmitBirthdate(event) {
        event.preventDefault();
        const { birth_month, birth_day, birth_year } = this.state;

        if (birth_month === 'Select Birth Month' || birth_day === 'Select Birth Day' || birth_year === 'Select Birth Year') {
            this.setState({ birthdate_error: "BIRTHDATE required!" });
            return;
        }
        const yyyy = birth_year;
        const mm = birth_month;
        const dd = this.pad2(birth_day);
        const birthdateString = this.buildBirthdateString(yyyy, mm, dd);
        if (!birthdateString) {
            this.setState({ birthdate_error: "Invalid BIRTHDATE selection!" });
            return;
        }
        if (!this.is18OrOlder(yyyy, mm, dd)) {
            this.setState({ birthdate_error: "You must be 18 years or older to continue!" });
            return;
        }

        this.setState({ isSubmittingBirthdate: true, birthdate_error: '' });
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                process.env.REACT_APP_SERVER_API + '/auth/update-birthdate',
                { birthdate: birthdateString },
                { headers: { Authorization: 'Bearer ' + token } }
            );
            if (response.data && response.data.message === 'SUCCESS') {
                const updatedUser = { ...this.state.user, birthdate: response.data.birthdate };
                localStorage.setItem('user', JSON.stringify(updatedUser));
                this.setState({ user: updatedUser, isSubmittingBirthdate: false });
            } else {
                this.setState({ isSubmittingBirthdate: false, birthdate_error: 'Something went wrong. Please try again.' });
            }
        } catch (err) {
            const msg = (err.response && err.response.data && err.response.data.error) || 'Something went wrong. Please try again.';
            this.setState({ isSubmittingBirthdate: false, birthdate_error: msg });
        }
    }

    renderBirthdateModal() {
        const { birth_month, birth_day, birth_year, birthdate_error, isSubmittingBirthdate } = this.state;
        return (
            <div
                className="home-birthdate-modal-overlay"
                role="dialog"
                aria-modal="true"
                aria-labelledby="home-birthdate-modal-title"
            >
                <div className="home-birthdate-modal-card">
                    <h3 id="home-birthdate-modal-title" className="home-birthdate-modal-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Confirm Your Birthdate</h3>
                    <p className="home-birthdate-modal-message">Please confirm your birthdate before continuing.</p>
                    <form onSubmit={this.onSubmitBirthdate}>
                        {birthdate_error && <p className="home-birthdate-modal-error">{birthdate_error}</p>}
                        <div className="home-birthdate-modal-dropdowns">
                            <select className="home-birthdate-modal-select" value={birth_month} onChange={this.onChangeBirthMonth} disabled={isSubmittingBirthdate}>
                                <option>Select Birth Month</option>
                                {this.birth_month_options()}
                            </select>
                            <select className="home-birthdate-modal-select" value={birth_day} onChange={this.onChangeBirthDay} disabled={isSubmittingBirthdate || birth_month === 'Select Birth Month'}>
                                <option>Select Birth Day</option>
                                {this.birth_day_options()}
                            </select>
                            <select className="home-birthdate-modal-select" value={birth_year} onChange={this.onChangeBirthYear} disabled={isSubmittingBirthdate}>
                                <option>Select Birth Year</option>
                                {this.birth_year_options()}
                            </select>
                        </div>
                        <button type="submit" className="home-birthdate-modal-submit" disabled={isSubmittingBirthdate}>
                            {isSubmittingBirthdate ? 'Saving…' : 'Confirm'}
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    formatEventDateTime(dateStr, timeStr) {
        if (!dateStr || !timeStr) return '';
        const dateOnly = String(dateStr).split('T')[0];
        const [year, month, day] = dateOnly.split('-').map(Number);
        const [h, m] = String(timeStr).split(':').map(Number);
        if (!year || !month || !day || isNaN(h) || isNaN(m)) return '';
        const d = new Date(year, month - 1, day, h, m);
        const dateFormatted = d.toLocaleDateString('en-US', {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
        const hour12 = h % 12 || 12;
        const minute = m.toString().padStart(2, '0');
        const period = h >= 12 ? 'PM' : 'AM';
        return `${dateFormatted} @ ${hour12}:${minute}${period}`;
    }

    renderHostText() {
        const event = this.state.upcomingEvent;
        if (!event || !event.host) return '';
        if (event.host.is_self) return 'You';
        return event.host.display_name || event.host.first_name || '';
    }

    renderAddress() {
        const event = this.state.upcomingEvent;
        if (!event || !event.address) return null;
        const { full, city, state, zip } = event.address;
        if (full) {
            const parts = full.split(',').map((p) => p.trim()).filter(Boolean);
            return (
                <p className="home-block-event-address">
                    {parts.map((part, i) => (
                        <Fragment key={i}>
                            {i > 0 && <br />}
                            {part}
                        </Fragment>
                    ))}
                </p>
            );
        }
        const cityState = [city, state].filter(Boolean).join(', ');
        const cityStateZip = zip ? `${cityState} ${zip}` : cityState;
        return <p className="home-block-event-address">{cityStateZip}</p>;
    }

    render() {
        if (this.state.status === 'unauthorized') {
            return <Navigate to="/signin" replace />;
        }
        if (this.state.status === 'verifying') {
            return (
                <div className="loading-screen">
                    <div className="loading-spinner"></div>
                </div>
            );
        }
        const { user, upcomingEvent } = this.state;
        const firstName = (user && user.first_name) || '';
        const needsBirthdate = !!user && !user.birthdate;
        return (
            <div className="home-container">
                {needsBirthdate && this.renderBirthdateModal()}
                <AccountHeader />
                {user && user.profile_image_url && (
                    <img className="home-profile-image" src={user.profile_image_url} alt="Your profile" />
                )}
                {user && (user.is_founding_member || (user.is_premium_community_only && user.is_legacy_pricing)) && (
                    <div className="home-badges-wrapper">
                        {user.is_founding_member && (
                            <span className="home-founding-badge" style={{fontFamily: "'Chelsea Market', cursive"}}>
                                <span className="home-founding-badge-icon">✨</span>
                                Founding Member
                            </span>
                        )}
                        {user.is_premium_community_only && user.is_legacy_pricing && (
                            <span className="home-legacy-badge" style={{fontFamily: "'Chelsea Market', cursive"}}>
                                <span className="home-legacy-badge-icon">💎</span>
                                Legacy Pricing
                            </span>
                        )}
                    </div>
                )}
                <div className="home-block">
                    <h2 className="home-block-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Hi {firstName}!</h2>
                    {user && user.account_suspended ? (
                        <div className="home-block-suspended">
                            <p className="home-block-suspended-message">
                                Your account has been suspended. If you have questions or believe this is a mistake, please contact us at <a href="mailto:hello@animates.app" className="home-block-suspended-link">hello@animates.app</a>.
                            </p>
                        </div>
                    ) : user && user.account_paused ? (
                        <div className="home-block-paused">
                            <img src={pausedMelodySleeping} alt="Melody sleeping" className="home-block-paused-image" />
                            <p className="home-block-paused-message">
                                Your account is paused — taking a break. Unpause anytime to come back to events, friends, and the community.
                            </p>
                        </div>
                    ) : (
                        <>
                            <h3 className="home-block-subtitle"><u>Your upcoming event:</u></h3>
                            {upcomingEvent ? (
                                <>
                                    <div className="home-block-event">
                                        <div className="home-block-event-info">
                                            <h4 className="home-block-event-title">{upcomingEvent.title}</h4>
                                            <p className="home-block-event-host">Hosted by: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#ED9594"}}>{this.renderHostText()}</span></p>
                                            {typeof upcomingEvent.attendee_count === 'number' && (
                                                <p className="home-block-event-attendees">Current Attendees: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#ED9594"}}>{upcomingEvent.attendee_count}</span></p>
                                            )}
                                            {upcomingEvent.date && upcomingEvent.time && (
                                                <p className="home-block-event-date">Date: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#ED9594"}}>{this.formatEventDateTime(upcomingEvent.date, upcomingEvent.time)}</span></p>
                                            )}
                                        </div>
                                        <hr className="home-block-event-divider" />
                                        <div className="home-block-event-address-stack">
                                            {this.renderAddress()}
                                            <img className="home-block-image" src={eventCardImage} alt="" />
                                        </div>
                                    </div>
                                    <p className="home-block-footer">View / Manage this event in the app.</p>
                                </>
                            ) : (
                                <p className="home-block-empty">You are currently not attending or hosting any events! 🥹</p>
                            )}
                        </>
                    )}
                </div>
                {!(user && user.account_suspended) && <HomeAffiliatePill user={user} />}
                <div className="home-account">
                    <h2 className="home-account-title color-1" style={{fontFamily: "'Chelsea Market', cursive"}}><u>Account:</u></h2>
                    {user && (() => {
                        const statusLabel = user.account_suspended ? 'Suspended' : (user.account_paused ? 'Paused' : 'Active');
                        const statusColor = user.account_suspended ? '#FF6B6B' : (user.account_paused ? '#F0C36D' : '#7DD3A4');
                        return (
                        <div className="home-account-details">
                            <div className="home-account-row">
                                <span>Account Status: <span style={{fontFamily: "'Chelsea Market', cursive", color: statusColor}}>{statusLabel}</span></span>
                            </div>
                            <div className="home-account-row">
                                <span>First Name: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#85C7DD"}}>{user.first_name || ''}</span></span>
                                <span>Last Name: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#85C7DD"}}>{user.last_name || ''}</span></span>
                            </div>
                            <div className="home-account-row">
                                <span>Email: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#85C7DD"}}>{user.email || ''}</span></span>
                                <span>Birthdate: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#85C7DD"}}>{this.formatBirthdate(user.birthdate)}{user.age ? ` (${user.age} yrs)` : ''}</span></span>
                            </div>
                            <div className="home-account-row">
                                <span>Email Verified: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#85C7DD"}}>{user.is_verified ? 'Yes' : 'No'}</span></span>
                                <span>Premium User: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#85C7DD"}}>{user.is_premium_community_only ? 'Yes' : 'No'}</span></span>
                            </div>
                            <div className="home-account-row">
                                <span>Current Location: <span style={{fontFamily: "'Chelsea Market', cursive", color: "#85C7DD"}}>{[user.city, user.state].filter(Boolean).join(', ')}</span></span>
                            </div>
                        </div>
                        );
                    })()}
                </div>
                {!(user && user.account_suspended) && (
                    <div className="home-settings">
                        <h2 className="home-settings-title color-1" style={{fontFamily: "'Chelsea Market', cursive"}}><u>Settings:</u></h2>
                        <div className="home-settings-list">
                            {!(user && (user.provider_type === 'APPLE' || user.provider_type === 'GOOGLE')) && (
                                <>
                                    <Link to="/change-email" className="home-settings-button">Change Email</Link>
                                    <Link to="/change-password" className="home-settings-button">Change Password</Link>
                                </>
                            )}
                            <Link to="/manage-subscription" className="home-settings-button">{user && user.is_premium_community_only ? 'Manage Subscription' : 'Subscribe to AniMates'}</Link>
                        </div>
                    </div>
                )}
                <div className="home-howto">
                    <h2 className="home-howto-title color-1" style={{fontFamily: "'Chelsea Market', cursive"}}><u>How To:</u></h2>
                    <div className="home-settings-list">
                        <Link to="/how-to-friends" className="home-settings-button">Friends</Link>
                        <Link to="/how-to-community" className="home-settings-button">Community</Link>
                        <Link to="/how-to-events" className="home-settings-button">Events</Link>
                        <Link to="/how-to-power-level" className="home-settings-button">Power Level</Link>
                        <Link to="/how-to-messages" className="home-settings-button">Messages</Link>
                        <Link to="/how-to-profile" className="home-settings-button">Profile</Link>
                    </div>
                </div>
                <div className="home-legal">
                    <h2 className="home-legal-title color-1" style={{fontFamily: "'Chelsea Market', cursive"}}><u>Legal:</u></h2>
                    <div className="home-settings-list">
                        <Link to="/rules" className="home-settings-button">Rules</Link>
                        <Link to="/terms-of-service" className="home-settings-button">Terms Of Service</Link>
                        <Link to="/privacy" className="home-settings-button">Privacy Policy</Link>
                        <Link to="/cookies" className="home-settings-button">Cookie Policy</Link>
                        <Link to="/child-safety" className="home-settings-button">Child Safety Standards</Link>
                    </div>
                </div>
                {!(user && user.account_suspended) && (
                    <div className="home-account-management">
                        <h2 className="home-account-management-title color-1" style={{fontFamily: "'Chelsea Market', cursive"}}><u>Account Management:</u></h2>
                        <div className="home-settings-list">
                            <Link to="/pause-account" className="home-settings-button">{user && user.account_paused ? 'Unpause Account' : 'Pause Account'}</Link>
                            <Link to="/delete-account" className="home-settings-button">Delete Account</Link>
                        </div>
                    </div>
                )}
                {!(user && user.account_suspended) && (
                    <div className="home-app-promo">
                        <p className="home-app-promo-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Get the AniMates app for the full experience</p>
                        <AppStoreButtons variant="home" />
                    </div>
                )}
                {/* 🔒 LAST on this page, deliberately — above the footer but below everything else.
                    It used to sit directly under the affiliate pill, which pushed the account
                    details, account management and app promo down by most of a screen on mobile.
                    A signed-in user is on /home for account management; events are a bonus, so they
                    go at the end. Same block, same data, same look as the splash — /public/events is
                    unauthenticated, so nothing here is personalised to this user.
                    ⚠️ Welcome.js's ordering is NOT the same and must stay as it is: on the splash the
                    block sits above the newsletter, which is correct there. */}
                <PublicEvents />
                <p className="home-footer">© 2026 AniMates. All rights reserved.</p>
            </div>
        );
    }
}

export default Home;
